import type { TeacherListParams } from '../types/teacher.types'

export const teachersKeys = {
  all: ['teachers'] as const,
  lists: () => [...teachersKeys.all, 'list'] as const,
  list: (params: TeacherListParams) =>
    [...teachersKeys.lists(), params] as const,
  details: () => [...teachersKeys.all, 'detail'] as const,
  detail: (id: string) => [...teachersKeys.details(), id] as const,
}
